export abstract class SystemKey {
  static ALL = ['system'];
}
